import React, { FunctionComponent, useState } from "react";
import {
  Fab,
  Button,
  Grid,
  Table,
  Dialog,
  MuiThemeProvider,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import Switch from "@material-ui/core/Switch";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import Tooltip from "@material-ui/core/Tooltip";
import MUIDataTable from "mui-datatables";

import { useDepartmentStyles } from "../useDepartmentStyles";
import { useStore } from "../../../store";
import { SnackBar } from "../../SnackBar";
import { useTableStyles } from "../../useTableStyle";
import { ThemeProvider } from "@mui/material/styles";

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = [
  "Name",
  "Code",
  "Status",
  "Report",
  "",
];

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

type DepartmentProps = {
  goToEdit: (id: number) => void;
  departments: any;
  editDepartmentPermission: boolean;
};

export const DepartmentTable: FunctionComponent<DepartmentProps> = ({
  goToEdit,
  departments,
  editDepartmentPermission
}) => {
  const classes = useDepartmentStyles();
  const getMuiTheme = useTableStyles();
  const [department, { updateDepartment, getDepartments }] = useStore(
    "departments"
  );
  const [status] = useStore("status");

  const [depStatus, setDepStatus] = useState<string>("");
  const [dept_id, setDept_id] = useState<number>();
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [departmentStatus, setDepartmentStatus] = useState<string>("");
  const [deptName, setDeptName] = useState<string>("");

  const handleChange = (id: number, status: string, name: string) => {
    setOpenConfirmation(true);
    setDeptName(name);
    setDepStatus(status);
    setDept_id(id);
  };

  const changeStatus = async (dept_status: string) => {
    try {
      const status_description =
        dept_status === "Active" ? "Inactive" : "Active";
      const statusId =
        status &&
        status.find((i: any) => i.description === status_description).id;

      const values = {
        status: statusId,
      };
      const result = await updateDepartment(dept_id, values);

      if (result !== undefined) {
        setOpenConfirmation(false);
        setSnackbarColor("green");
        setDepartmentStatus("Status updated successfully");
        await getDepartments();
      }
    } catch (error:any) {
      console.log(error);
      setSnackbarColor("red");
      setDepartmentStatus(error.error);
    }
  };

  const onCloseSnackbar = () => {
    setDepartmentStatus("");
  };

  if (departments && departments.length > 0) {
    return (
      <div className={classes.root1}>
        <SnackBar
          status={departmentStatus}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Department List"}
              data={departments.map((department: any) => {
                return [
                  department.departmentname,
                  department.code,
                  department.status,
                  department.report === true ? "Yes" : "No",
                  <Grid container direction="row" spacing={2} justify="flex-end"
                    style={{ display: editDepartmentPermission ? "" : "none" }}
                  >
                    <Grid item>
                      <Tooltip title="Edit">
                        <Fab
                          size="small"
                          aria-label="edit"

                          className={classes.editIconMargin}
                          onClick={() => goToEdit(department.department_id)}
                        >
                          <EditIcon className={classes.editIcon} />
                        </Fab>
                      </Tooltip>
                    </Grid>
                    <Grid item>
                      <Tooltip
                        title={
                          department.status_description === "Active"
                            ? "Change status to Inactive"
                            : "Change status to Active"
                        }
                      >
                        <Switch
                          checked={department.status === 1 ? true : false}
                          onChange={() =>
                            handleChange(
                              department.department_id,
                              department.status_description,
                              department.departmentname
                            )
                          }
                          style={{color:department.status_description === "Active"?"#3d5a79": undefined}}
                          color="primary"
                          name="status"
                          inputProps={{ "aria-label": "primary checkbox" }}   
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                ];
              })}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Table>
        <Dialog
          open={openConfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {depStatus === "Active"
                ? `Would you like to change status of ${deptName} to Inactive?`
                : `Would you like to change status of ${deptName} to Active?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => changeStatus(depStatus)} id="buton">
              Yes
          </Button>
            <Button
              onClick={() => setOpenConfirmation(false)}
              autoFocus
              id="buton"
            >
              No
          </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return (
      <div className={classes.root}>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Department List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
